import styled, { css } from 'styled-components';
import { Size } from '../../common/size';
import React from 'react';
import { IThemePalette } from '../../Themes/interfaces';
import { baseFontCss } from '../../common/mixins';

export const linkColours = (palette: IThemePalette) => ({
  link: {
    text: palette.secondary.first[100]
  }
});

export interface ILinkBaseProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  size?: Size;
}

const sizeStyles: Record<Size, ReturnType<typeof css>> = {
  [Size.ExtraSmall]: css`
    font-size: ${({ theme }) => theme.text.sizeExtraSmall};
    line-height: ${({ theme }) => theme.text.lineHeightSmall};
  `,
  [Size.Small]: css`
    font-size: ${({ theme }) => theme.text.sizeSmall};
    line-height: ${({ theme }) => theme.text.lineHeightSmall};
  `,
  [Size.Medium]: css`
    font-size: ${({ theme }) => theme.text.sizeMedium};
    line-height: ${({ theme }) => theme.text.lineHeight};
  `,
  [Size.Large]: css`
    font-size: ${({ theme }) => theme.text.sizeLarge};
    line-height: ${({ theme }) => theme.text.lineHeight};
  `,
  [Size.ExtraLarge]: css`
    font-size: ${({ theme }) => theme.text.sizeExtraLarge};
    line-height: ${({ theme }) => theme.text.lineHeight};
  `
};

export const Link = styled.a<ILinkBaseProps>`
  ${baseFontCss};
  color: ${({ theme }) => theme.colours.link.text};
  text-decoration: none;
  ${({ size = Size.Medium }) => sizeStyles[size]};
  :hover,
  :active,
  :focus {
    text-decoration: underline;
  }
`;
